require('./aggregatorShareDetails.scss');

import React from 'react';
import PropTypes from 'prop-types';

// @components
import { AggregatorTableDetails } from 'components/aggregator/aggregatorDetails/aggregatorTableDetails/aggregatorTableDetails';

// @helpers
import { getFlagUrl } from 'utilities/flagHelper';

// @constants
const TRANSLATION_KEY_PREFIX = "AggregatorShareDetails";

const { FormattedText } = require('core/i18n').i18n;

class AggregatorShareDetails extends React.PureComponent {

    buildName = (item) => {
        const shareName = item.get('name');
        const contractFlag = getFlagUrl(item.get('isoCountryCode', 'ES'), 20);
        const contractMarket = item.get('market');

        return (
            <div className="aggregator-share-details__name">
                <div className="aggregator-share-details__name__title">
                    {shareName}
                </div>
                <div className="aggregator-share-details__name__contract">
                    <img className="aggregator-share-details__name__contract__flag" src={contractFlag}/>
                    <span className="aggregator-share-details__name__contract__market">
                        {contractMarket}
                    </span>
                </div>
            </div>
        );
    };

    buildItem = (item, isTinkAggregator) => {
        const quantity = item.get('quantity');
        const unitPrice = item.get('unitPrice');
        const valueDate = !isTinkAggregator ? item.get('valueDate') : item.get('valuationDate');
        const stockBalance = item.get('stockBalance');

        return [{
            type: 'custom',
            value: this.buildName(item)
        },{
            type: 'number',
            value: quantity,
        },{
            type: 'amount',
            value: unitPrice,
            bold: true,
        },{
            type: 'date',
            value: valueDate,
        },{
            type: 'amount',
            value: stockBalance,
            bold: true,
        }];
    };

    buildTableValues = () => {
        const { products, isTinkAggregator } = this.props;

        return products.map(item => this.buildItem(item, isTinkAggregator));
    };

    buildTableHeader = () => {
        return [
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-name`} value={`${TRANSLATION_KEY_PREFIX}-name`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-titles`} value={`${TRANSLATION_KEY_PREFIX}-titles`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-quotation`} value={`${TRANSLATION_KEY_PREFIX}-quotation`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-valorationDate`} value={`${TRANSLATION_KEY_PREFIX}-valorationDate`}/>,
            <FormattedText key={`${TRANSLATION_KEY_PREFIX}-value`} value={`${TRANSLATION_KEY_PREFIX}-value`}/>
        ];
    };

    render() {
        const header = this.buildTableHeader();
        const values = this.buildTableValues();

        return (
            <AggregatorTableDetails
                investmentTable={true}
                values={values}
                header={header}
            />
        );
    }
}

AggregatorShareDetails.propTypes = {
	products: PropTypes.object,
    isTinkAggregator: PropTypes.bool
}

export { AggregatorShareDetails };
